import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { EventTargetInterruptSource, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TourService } from 'ngx-tour-md-menu';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../shared/config/app-config';
import { SessiontempComponent } from '../../sessiontemp/sessiontemp.component';
import { Errors, Puser, User } from '../models';
import { CallService, PatientService, UserService } from '../services';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'layout-header',
	templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
	showBrowser: boolean = false;
	ulname: any;
	ufname: any;
	public timealert = environment.timelimit;
	uname: any;
	errors: Errors = new Errors();
	isSubmitting = false;
	reauth: FormGroup;
	routelink: string;
	lengthcn: any;
	messages1: any;
	message1: any;
	menumsg: any;
	show = false;
	count = 0;
	username: any = "";
	password: any = "";
	public data1: Object;
	reportData: any = {};
	temp_var: any;
	mytodo: any = [];
	enable: any = true;
	type: any = false;
	range: any;
	public idletime: any = environment.idletime;
	public setidletime: any = environment.timeset;
	public apiurl: any = environment.api_url;
	public caremap: any = environment.practiceid;
	idleState = 'NOT_STARTED';
	timedOut = false;
	lastPing?: Date = null;
	progressBarPopup: MatDialogRef<SessiontempComponent>;
	useracc: string;
	careList: any;
	selCare: any;
	public ModelRef: BsModalRef;
	qualificationcount: number;
	dropdownCNVisb: any = true;
	prefLang: string = this.userService.cnDefaultLang;
	constructor(
		private router: Router,
		private userService: UserService,
		private callService: CallService,
		private patientservice: PatientService,
		public tourService: TourService,
		private fb: FormBuilder,
		private dialog: MatDialog,
		private element: ElementRef,
		private idle: Idle,
		private keepalive: Keepalive,
		private route: ActivatedRoute,
		private toast: ToastrService,
		private modalService: BsModalService,
		private datePipe: DatePipe,
		private translate: TranslateService
	) {
		this.translate.setDefaultLang(userService.defaultLang);
		this.reauth = this.fb.group({
			'password': ['', Validators.required]
		});
		let showDrop = false;
		// let url = window.location.href.split("#"); 
		// ////console.log("URL",url[1]);
		router.events.subscribe((val) => {
			// see also 
			// ////console.log(val instanceof NavigationEnd, "Navigation") 
			let urls = ["/care/patientlist", "/care/patientqualification", "/care/mytodo", "/care/messages", "/care/appointments"]
			let url = window.location.href.split("#");
			if (urls.includes(url[1])) {
				//showDrop =true;
				this.patientservice.showDrop = true;

				////console.log("SWFID PAtient", window.localStorage['patid']  )
				if (window.localStorage['patientId']) {
					window.localStorage.removeItem('patientId');
				}
				if (window.localStorage['patSWFId']) {
					window.localStorage.removeItem('patSWFId');
				}

			} else {
				this.patientservice.showDrop = false;
			}
		});

		if (window.localStorage['langChangedByUser']) 				//to remove 
			window.localStorage.removeItem('langChangedByUser');
	}

	currentUser: User;
	currentUserSub?: Subscription;
	currentUserSub1?: Subscription;
	menu: any;
	messages: any;
	hideEnroller: boolean = false;
	hideFCN: boolean = false;
	status: any = {
		message: false,
		todo: false,
		appoinment: false,
		reports: false,
		snfpatient: false,
		priortype: false,
		patientlist: false,
		patientreport: false,
		patreport: false,
		ismenuview: false,
		ismenuedit: false,
		isappedit: false,
		isappview: false,
		ispatedit: false,
		ispatview: false,
		ispatrepodit: false,
		ispatrepoview: false,
		ispatrepedit: false,
		ispatrepview: false,
		issnfedit: false,
		issnfview: false,
		istodoview: false,
		istodoedit: false,
		isprioredit: false,
		ispriorview: false,
		isreportedit: false,
		isreportview: false
	};
	PUser: Puser;
	subscription: Subscription;
	length: any;
	resp: any
	public imageURL: string = environment.cloudeImageURL;
	dateformat: any = environment.dateFormat
	lastLoginDate: any

	ngOnInit() {
		this.currentUserSub?.unsubscribe();
		this.currentUserSub1?.unsubscribe();
		this.dropdownCNVisb = true;
		this.getBrowserDetect()
		this.getCurrenUser()
		this.assignUser()
		this.currentUserSub = this.userService.currentUser.subscribe(
			(userData) => {
				this.currentUser = userData;
				this.lastLoginDate = window.localStorage['LLD']

				if (this.currentUser.item) {
					this.currentUser.item.setmask = this.currentUser.item.phoneFormat.split('#').join('0');
					this.currentUser.item.length = this.currentUser.item.phoneFormat.split('#').join("").length
				}
			}
		)
	}

	getBrowserDetect() {
		if (navigator.userAgent.search("Android") != -1) {
			//////console.log(BrowserDetect.version)
			//	this.showBrowser = true;
			//alert("Call");
		}
	}

	session() {
		// sets an idle timeout of 15 minutes.
		this.idle.setIdle(5);
		// sets a timeout period of 5 minutes.
		this.idle.setTimeout(10);
		// sets the interrupts like Keydown, scroll, mouse wheel, mouse down, and etc
		this.idle.setInterrupts([
			new EventTargetInterruptSource(
				this.element.nativeElement, 'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll')
		]);

		this.idle.onIdleEnd.subscribe(() => {
			this.idleState = 'NO_LONGER_IDLE';

		});

		this.idle.onTimeout.subscribe(() => {
			this.idleState = 'TIMED_OUT';
			this.timedOut = true;
			this.closeProgressForm();
			this.logout();
		});

		this.idle.onIdleStart.subscribe(() => {
			this.idleState = 'IDLE_START';
			this.openProgressForm(1);
		});

		this.idle.onTimeoutWarning.subscribe((countdown: any) => {
			this.sessionForm(countdown);


		});

		// sets the ping interval to 15 seconds
		this.keepalive.interval(15);

		/**
		 *  // Keepalive can ping request to an HTTP location to keep server session alive
		 * keepalive.request('<String URL>' or HTTP Request);
		 * // Keepalive ping response can be read using below option
		 * keepalive.onPing.subscribe(response => {
		 * // Redirect user to logout screen stating session is timeout out if if response.status != 200
		 * });
		 */
		this.reset();
	}

	loadCareList() {
		this.userService.getCareList(this.currentUser.item.userAccountKey, this.currentUser.item.userAccountId).subscribe(
			data => {
				this.careList = data;
				this.lengthcn = this.careList.length
				if (this.currentUser.item.cnmappingct == 0 || this.currentUser.item.userAccountId == this.caremap) {
					this.selCare = 'ALL'
				}
				else {
					let selcnid = data.find(it => it.CNID == this.currentUser.item.userAccountId)
					if (selcnid)
						this.selCare = selcnid.CNID;
					else
						this.selCare = 'ALL'
					this.currentUser.item.selectCNUserId = this.selCare;
				}
				this.setCNDropDownValue();
			}
		);
	}

	setCNDropDownValue() {
		setTimeout(() => {
			const cnDropElement = document.getElementById("reportChange") as HTMLSelectElement;
			if (cnDropElement) {
				cnDropElement.value = this.selCare;
			}
		}, 1000);
	}

	hrologin_url: any = environment.hrologin_url
	navigateToReport() {

		this.enable = false;
		this.logout();
		window.location.href = this.hrologin_url
		// this.userService.getReportURL()
		// 	.subscribe(
		// 		data => {
		// 			this.reportData = data;
		// 			//this.userService.purgeAuth();
		// 			if (window.localStorage['plogin']) {
		// 				// var plogin = window.localStorage['plogin']
		// 				window.localStorage.removeItem('plogin');
		// 			}
		// 			window.location.href = this.reportData.RCReportInfo.RCReport;

		// 		}
		// 	);

	}
	getqualificationcount() {
		this.patientservice.getcountqual('Default', this.currentUser.item.userAccountId, this.currentUser.item.selectCNUserId).subscribe(
			data => {
				if (data)
					this.currentUser.item.pqtlength = parseInt(data.Count)
			}
		)
	}


	getCurrenUser() {
		this.currentUserSub1 = this.userService.currentUser.subscribe(
			(userData) => {
				this.currentUser = userData;
				this.currentUser.operationMessage = ''

				setTimeout(() => {
					try {
						if (this.currentUser.item.hostModel == "CLOUD")
							this.imageURL = environment.cloudeImageURL;
						else
							this.imageURL = environment.vmImageURL;
					} catch (e) { }
				}, 1000);

				if (this.currentUser.item) {
					if (this.currentUser.item.userGroupId) {
						if (this.currentUser.item.userrole == 'Patient Enroller' || this.currentUser.item.userGroupId == 18 || this.currentUser.item.userGroupId == 31 || this.currentUser.item.userGroupId == 30) {
							this.hideEnroller = true;
						}
						if (this.currentUser.item.userGroupId == 28) {
							this.hideFCN = true;
						}
						if (this.currentUser.item.userGroupId == 30 || this.currentUser.item.userGroupId == 31 || this.currentUser.item.userGroupId == 32 || this.currentUser.item.userGroupId == 33)
							this.dropdownCNVisb = false;
						else
							this.dropdownCNVisb = true;
						this.getmenu();
					}
					this.useracc = this.currentUser.item.userAccountId;
					this.patientservice.userId = this.currentUser.item.userAccountId;
					if (this.currentUser.item.cnmappingct == 0 || this.currentUser.item.userAccountId == this.caremap) {
						this.selCare = 'ALL'
						this.patientservice.CN_id = "0"
						this.currentUser.item.selectCNUserId = "0"
					} else {
						this.selCare = this.currentUser.item.userAccountId;
						this.patientservice.CN_id = this.currentUser.item.userAccountId;
						this.currentUser.item.selectCNUserId = this.currentUser.item.userAccountId;
					}
					if (this.currentUser.item.appRoles != 'PATIENT') {
						this.getmytodolength();
						if (!this.careList) {
							this.loadCareList();			//Load Care navigator or Coordinator for bind header dropdown
						}
						if (this.currentUser.item.commercialType)
							this.getqualificationcount();
					}
					if (this.currentUser.item.landingPage == 'CC_TO_DO') {
						this.routelink = '/care/mytodo'
					} else if (this.currentUser.item.landingPage == 'AD_PATIENTQUALIFICATION') {
						this.routelink = '/care/patientqualification'
					}
					else {
						this.routelink = '/care/patientlist'
					}
				}
			}
		)
	}

	getmytodolength() {
		if (window.localStorage['startdate'] && window.localStorage['enddate']) {
			this.patientservice.countrange(this.currentUser.item.userAccountId, window.localStorage['startdate'], window.localStorage['enddate']).subscribe(
				data => {
					this.currentUser.item.mytodolength = data.todoCount
					this.currentUser.item.msgcount = data.messageCount;
				}
			);
		}
		else {
			this.patientservice.countrange(this.currentUser.item.userAccountId, 'N', 'N').subscribe(
				data => {
					this.currentUser.item.mytodolength = data.todoCount
					this.currentUser.item.msgcount = data.messageCount;
				}
			);
		}
		this.subscription = this.patientservice.Mytodo.subscribe(item => {
			this.length = item;
		})
	}

	logout() {
		this.resetTimeOut();
		this.userService.logoutuser(this.useracc)
		this.hideEnroller = false;
		window.localStorage.removeItem('ccdetails');
		window.localStorage.removeItem('adminnamefname');
		window.localStorage.removeItem('adminnamelname');
		window.localStorage.removeItem('stykerAdminUser')
		//this.currentUser.status==false
		if (window.localStorage['patpwd']) {
			window.localStorage.removeItem('patpwd');
		}
		if (window.localStorage['pwd']) {
			window.localStorage.removeItem('pwd');
		}
		if (window.localStorage['onBehalfName']) {
			window.localStorage.removeItem('onBehalfName');
		}
		if (window.localStorage['plogin']) {
			var plogin = window.localStorage['plogin']
			window.localStorage.removeItem('plogin');
			this.userService.purgeAuth();
			this.router.navigateByUrl('/plogin/' + plogin);
		}
		else {
			this.userService.purgeAuth();
			this.router.navigateByUrl('/login');
		}
		if (this.ModelRef)
			this.ModelRef.hide()
		this.errors = new Errors();
	}

	getmenu() {	//this.currentUser.item.userAccountId
		this.userService.menuuserinfo(this.currentUser.item.userGroupId, this.currentUser.item.userAccountId).subscribe(data => {
			this.menu = data;
			if (this.menu) {
				for (var i = 0; i < this.menu.length; i++) {
					if (this.menu[i].refName == 'CC_MESSAGES') {
						this.status.message = this.menu[i].status
						this.status.ismenuview = this.menu[i].isView
						this.status.ismenuedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'CC_REPORT') {
						this.status.reports = this.menu[i].status
						this.status.isreportview = this.menu[i].isView
						this.status.isreportedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'CC_TO_DO') {
						this.status.todo = this.menu[i].status
						this.status.istodoview = this.menu[i].isView
						this.status.istooedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'CC_APPOINTMENT') {
						this.status.appoinment = this.menu[i].status
						this.status.isappview = this.menu[i].isView
						this.status.isappedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'CC_SNFPATIENT') {
						this.status.snfpatient = this.menu[i].status
						this.status.issnfview = this.menu[i].isView
						this.status.issnfedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'CC_PRATICE_REPORTS') {
						this.status.patientreport = this.menu[i].status
						this.status.ispatrepview = this.menu[i].isView
						this.status.ispatrepedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'CC_ADV_PATIENTLIST') {
						this.status.patientlist = this.menu[i].status
						this.status.ispatview = this.menu[i].isView
						this.status.ispatedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'HPH_PriorityType') {
						this.status.priortype = this.menu[i].status
						this.status.ispriorview = this.menu[i].isView
						this.status.isprioredit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'PAT_REPORT') {
						this.status.patreport = this.menu[i].status
						this.status.ispatrepoview = this.menu[i].isView
						this.status.ispatrepoedit = this.menu[i].IsEdit
					} else if (this.menu[i].refName == 'AD_PATIENTQUALIFICATION') {
						this.status.patqualifi = this.menu[i].status
						this.status.ispatqualifiview = this.menu[i].isView
						this.status.ispatqualifiedit = this.menu[i].IsEdit
					}
				}
			}
		})
	}

	assignUser() {
		this.userService.PUser.subscribe(
			(userData) => {
				this.resp = userData;
			}
		)
	}

	startTour() {
		if (this.dropdownCNVisb) {
			this.tourService.initialize([{
				anchorId: 'start',
				content: 'Document for planning for optimal hospital discharge date (LOS), post-surgical discharge location and LOS, using a risk assessment and predictive algorithms When: Either after a patient completes their Home and Health Assessments or have not within 3 weeks of surgery ',
				title: 'Generate Care Plan',
				placement: 'right-top',
			}, {
				anchorId: 'start1',
				content: 'Mechanism for tracking actual hospital discharge date, discharge disposition, and post-surgical facility name When:Patients appear one day prior to planned hospital discharge (default to 2 days after day of surgery, unless changed by you)',
				title: 'Track Hospital Discharge'
			}, {
				anchorId: 'start2',
				content: 'Alert to contact the SNF facility for tracking discharge date (LOS) When: Displays starting 5 days after actual hospital discharge date, and continues every 5 days until actual SNF discharge date is documented',
				title: 'Follow up with PSC'
			}, {
				anchorId: 'start3',
				content: 'Review patients who have reported adverse symptom(s) via check-in and check-up assessments after surgery to help you manage by exception and follow-up When: 1, 2, 3, 4, 6, 8, 10, 12 days after surgery',
				title: 'View New Symptoms'
			}], {
				route: this.routelink
			});
			this.tourService.start();
		}
	}

	carenav(care) {
		//alert("CALL")
		this.clearFilter();
		var url = [];
		url = window.location.href.split("#");
		var urls = ["/care/patientlist", "/care/patientqualification", "/care/mytodo", "/care/messages"]
		if (urls.includes(url[1])) {
			this.patientservice.userFilter = false
			if (care != 'ALL')
				this.patientservice.userFilter = true;
			if (this.patientservice.userFilter) {
				this.currentUser.item.selectCNUserId = care;
				this.patientservice.CN_id = care;
			} else {
				this.patientservice.CN_id = "0"
			}
			if (url[1] == '/care/patientlist') {
				this.callService.patcallComponentMethod();
			}
			else if (url[1] == '/care/patientqualification') {
				this.callService.pqtcallComponentMethod();
			}
			else if (url[1] == '/care/mytodo') {
				this.callService.mytodocallComponentMethod();
			}
			else if (url[1] == '/care/messages') {
				this.callService.messagescallComponentMethod();
			}
		}

		////console.log("Current USerId", this.currentUser.item.userAccountId);

		this.getmytodolength()
		if (this.currentUser.item.commercialType)
			this.getqualificationcount();

		////console.log(window.location.href.split("#"));

	}

	clearFilter() {
		window.localStorage.removeItem('alltodoFilter')
		window.localStorage.removeItem('completedFilter')
		window.localStorage.removeItem('gcpFilter')
		window.localStorage.removeItem('gcpCompletedFilter')
		window.localStorage.removeItem('thdFilter')
		window.localStorage.removeItem('thdCompletedFilter')
		window.localStorage.removeItem('followupFilter')
		window.localStorage.removeItem('followUpCompletedFitler')
		window.localStorage.removeItem('vnsFilter')
		window.localStorage.removeItem('vnsCompletedFilter')
		window.localStorage.removeItem('patFilter')
		window.localStorage.removeItem('patQualiFilter')
		window.localStorage.removeItem('appoinmentFilter')
		window.localStorage.removeItem('startdate');
		window.localStorage.removeItem('enddate');
		window.localStorage.removeItem('setBugetFilter');
		window.localStorage.removeItem('maintainCareList');
		window.localStorage.removeItem('maintainReassign');

	}

	ngOnDestroy() {
		this.resetTimeOut();
		if (this.ModelRef)
			this.ModelRef.hide()
		this.currentUserSub?.unsubscribe();
		this.currentUserSub1?.unsubscribe();
	}

	reverseNumber(countdown: number) {
		return (300 - (countdown - 1));
	}

	reset() {
		this.idle.watch();
		this.idleState = 'Started.';
		this.timedOut = false;
		// this.logout();
	}

	public openProgressForm(count: number) {

		this.progressBarPopup = this.dialog.open(SessiontempComponent, {
			hasBackdrop: true,
			disableClose: true
		});
		this.progressBarPopup.componentInstance.count = count;

		this.progressBarPopup.afterClosed().subscribe(result => {
			if (result != '' && 'logout' == result) {
				this.logout();
			} else {
				this.reset();
			}
		});
	}
	public sessionForm(countdown: any): any {
		this.idleState = 'IDLE_TIME_IN_PROGRESS';
		//this.progressBarPopup = this.dialog.open(SessiontempComponent)
		this.progressBarPopup.componentInstance.count = (Math.floor((countdown - 1) / 60) + 1);
		// ////console.log(this.progressBarPopup.componentInstance.count)
		this.progressBarPopup.componentInstance.progressCount = this.reverseNumber(countdown);
		this.progressBarPopup.componentInstance.countMinutes = (Math.floor(countdown / 60));
		this.progressBarPopup.componentInstance.countSeconds = countdown % 60;
	}


	closeProgressForm() {
		this.progressBarPopup.close();
		this.resetTimeOut()
	}

	resetTimeOut() {
		this.idle.stop();
		this.idle.onIdleStart.unsubscribe();
		this.idle.onTimeoutWarning.unsubscribe();
		this.idle.onIdleEnd.unsubscribe();
		this.idle.onIdleEnd.unsubscribe();


	}

	logoutconfirm(confirm: TemplateRef<any>) {

		if (window.localStorage['adminnamefname'] && window.localStorage['adminnamelname']) {
			this.ufname = window.localStorage['adminnamefname'];
			this.ulname = window.localStorage['adminnamelname'];
		} else if (window.localStorage['ccdetails']) {
			let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
			this.ufname = ccdetails.ccnamefname
			this.ulname = ccdetails.ccnamelname
		}
		let self = this;
		////console.log(window.localStorage['cnusername']);
		if ((window.localStorage['adminnamefname'] != '' && window.localStorage['adminnamelname'] != undefined && window.localStorage['superClientId']) || (window.localStorage['ccdetails'] && this.currentUser.item.appRoles == 'PATIENT')) {
			this.ModelRef = self.modalService.show(confirm, {
				class: 'modal-md',
				backdrop: 'static'
			})
			this.movable()
			this.password = ''
		} else {
			this.logout();
		}


	}
	toggleShow(event, id, inputid) {
		this.show = !this.show;

		if (this.show) {
			$(`#${id}`).removeClass('fa-eye')
			$(`#${id}`).addClass('fa-eye-slash')
			let input = $(`#${inputid}`);
			input.attr('type', 'text')
		} else {
			$(`#${id}`).removeClass('fa-eye-slash')
			$(`#${id}`).addClass('fa-eye')
			let input = $(`#${inputid}`);
			input.attr('type', 'password')

		}
	}
	new() {
		this.errors = new Errors();
		this.ModelRef.hide()
	}
	logintocc() {
		let uname;
		if (window.localStorage['ccdetails'] && !window.localStorage['stykerAdminUser']) {
			let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
			uname = ccdetails.cnusername
		} else if (window.localStorage['stykerAdminUser']) {
			uname = window.localStorage['stykerAdminUser']
		}
		this.isSubmitting = true;
		this.errors = new Errors();
		const credentials = {
			'username': uname,
			'password': btoa(this.reauth.value.password),
			'captcha': '',
			'mode': '',
			'usermode': 'c',
			'forcelogin': 'true'
		}
		// if(this.prefLang && this.prefLang !== this.userService.defaultLang) {
        //     this.userService.setCurrentLanguage(this.prefLang || this.userService.cnDefaultLang);
		// }
		var jwtToken = localStorage.getItem('jwtToken')
		window.localStorage.removeItem('jwtToken');
		window.localStorage.removeItem('userModeFlag')
		window.localStorage.removeItem('WFD');
		this.userService
			.attemptAuth(credentials)
			.subscribe(

				data => {
					window.localStorage.removeItem('Puser');
					window.localStorage.removeItem('session');
					this.idle.setIdle(this.idletime);
					this.idle.setTimeout(this.setidletime);
					this.ModelRef.hide()
				},
				err => {
					window.localStorage.setItem('jwtToken', jwtToken);
					err = this.userService.decrypt(err.data)
					this.errors = err;
					this.isSubmitting = false;

				}
			);
	}

	// getPreferredLanguage() {
	// 	let targetEmail;
	// 	if (window.localStorage['ccdetails'] && !window.localStorage['stykerAdminUser']) {
	// 		let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
	// 		targetEmail = ccdetails.cnusername
	// 	} else if (window.localStorage['stykerAdminUser']) {
	// 		targetEmail = window.localStorage['stykerAdminUser']
	// 	}
	// 	const credential = {
	// 	  'userName': targetEmail
	// 	}
	// 	this.userService.getLanguageConfig(credential).subscribe(
	// 	  langConfigRes => {
	// 		if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
	// 		  if(langConfigRes?.multiLanguageRequired) {
	// 			this.prefLang = langConfigRes?.preferredlanguage;
	// 		  }
	// 		}
	// 	});
	// }

	setonboard() {
		let self = this;
		self.userService.getOnboardURL()
			.subscribe(data => {

				if (data.RCReportInfo.status == 'success') {
					this.navigateonboard()
				}
				else {
					this.toast.error(this.userService.translateText('patient_portal.display_messages.not_authorized_user'), '', {
						timeOut: this.timealert
					})
				}
			})

	}

	navigateonboard() {
		let self = this;
		self.patientservice.getPatientPassword(self.currentUser.item.userId, self.currentUser.item.userAccountId)
			.subscribe(data => {
				////console.log(data)
				if (data.item.status == 'success') {
					var userEnc = encodeURIComponent(btoa(data.item.uname));
					var pasEnc = encodeURIComponent(data.item.pwd);
					// window.location.href = window.localStorage['superClientId'] ? environment.directobgin_url + '/#/oblogin/' + userEnc + "/" + pasEnc + "/" + String(window.localStorage['superClientId']): environment.directobgin_url + '/#/oblogin/' + userEnc + "/" + pasEnc + "/0" ;
					window.location.href = environment.directobgin_url + '/#/oblogin/' + userEnc + "/" + pasEnc + "/"

				}
			})
	}
	movable() {
		$(function () {
			let modalContent: any = $('.modal-content');
			let modalHeader = $('.modal-header');
			modalHeader.addClass('cursor-all-scroll');
			modalContent.draggable({
				handle: '.modal-header'
			});
		});
	}

	get onBehalfName(): any {
		return window.localStorage['onBehalfName'] ? window.localStorage['onBehalfName'] : this.currentUser.item.carePartnerPatientName;
	}

	closeBrowserSupport() {
		this.showBrowser = false;
	}
	switchportal() {
		if (window.localStorage['stykerAdminUser']) {
			let self = this;
			self.patientservice.getPatientPassword(window.localStorage['stykerAdminUser'], this.currentUser.item.userAccountId)
				.subscribe(data => {
					if (data.item.status == 'success') {
						const credentials = {
							'username': data.item.uname,
							'password': data.item.pwd,
							'captcha': '',
							'mode': '',
							'usermode': 'c',
							'forcelogin': 'true'
						}
						let adminId = self.currentUser.item.userAccountId
						self.userService.logAudit('getPassword', 0).subscribe(data => { })
						this.userService
							.attemptAuth(credentials)
							.subscribe(
								data => {
									if (data && adminId) {
										window.localStorage['superClientId'] = adminId
										// this.router.navigateByUrl('/Demoportal');
									}
									window.localStorage.removeItem('session');
								}
							);
					}
				})
		} else if (window.localStorage['Multi']) {
			let self = this;
			self.patientservice.getPatientPassword(this.currentUser.item.email, this.currentUser.item.userAccountId)
				.subscribe(data => {
					if (data.item.status == 'success') {
						const credentials = {
							'username': data.item.uname,
							'password': data.item.pwd,
							'captcha': '',
							'mode': '',
							'usermode': 'c',
							'forcelogin': 'true',
							'language': this.userService.selectedLang
						}
						self.userService.logAudit('getPassword', 0).subscribe(data => { })
						window.localStorage.removeItem('Multi');
						this.userService
							.attemptAuth(credentials)
							.subscribe(
								data => {
									window.localStorage.removeItem('session');
								}
							);
					}
				})
		}
	}
	switchportalshow() {
		if (window.localStorage['stykerAdminUser'] || window.localStorage['Multi'])
			return true
		else
			return false
	}
}
